(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.cacheHeaderHeights();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.cacheHeaderHeights.bind(this));
      window.addEventListener('resize', () => {
        window.clearTimeout(this.headerResizeTimer);
        this.headerResizeTimer = setTimeout(() => this.cacheHeaderHeights(), 150);
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    /** Measure expanded + compact heights off-DOM so the live header never flashes. */
    cacheHeaderHeights() {
      if (!this.header) return;

      const width = this.header.offsetWidth || document.documentElement.clientWidth;
      const clone = this.header.cloneNode(true);
      clone.classList.remove('header-compact', 'scrolled-past-header', 'menu-open');
      clone.setAttribute('aria-hidden', 'true');
      clone.style.cssText = [
        'position: fixed',
        'left: -9999px',
        'top: 0',
        'width: ' + width + 'px',
        'visibility: hidden',
        'pointer-events: none',
        'z-index: -1',
      ].join(';');

      // Kill transitions/animations on the clone so height reads are instant
      const style = document.createElement('style');
      style.textContent =
        '.header-height-probe, .header-height-probe * { transition: none !important; animation: none !important; }';
      clone.classList.add('header-height-probe');
      document.documentElement.appendChild(style);
      document.documentElement.appendChild(clone);

      void clone.offsetHeight;
      const expanded = clone.offsetHeight;
      document.documentElement.style.setProperty('--header-expanded-height', `${expanded}px`);

      clone.classList.add('header-compact');
      void clone.offsetHeight;
      const compact = clone.offsetHeight;
      document.documentElement.style.setProperty('--header-compact-height', `${compact}px`);

      clone.remove();
      style.remove();

      const current = this.header.classList.contains('header-compact') ? compact : expanded;
      document.documentElement.style.setProperty('--header-height', `${current}px`);
      document.documentElement.classList.toggle(
        'header-compact',
        this.header.classList.contains('header-compact')
      );
    }

    setHeaderHeight() {
      const h = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${h}px`);
      if (this.header.classList.contains('header-compact')) {
        document.documentElement.style.setProperty('--header-compact-height', `${h}px`);
      } else {
        document.documentElement.style.setProperty('--header-expanded-height', `${h}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Always-sticky: background after a short scroll; compact height with hysteresis
      // so shrinking the header doesn't drop scrollY back under the enter threshold
      // and flip compact on/off (visible flicker).
      if (this.headerIsAlwaysSticky) {
        this.header.classList.toggle('scrolled-past-header', scrollTop > 12);
        const wasCompact = this.header.classList.contains('header-compact');
        const COMPACT_ENTER = 100;
        const COMPACT_EXIT = 40;
        const isCompact = wasCompact ? scrollTop > COMPACT_EXIT : scrollTop > COMPACT_ENTER;
        this.header.classList.toggle('header-compact', isCompact);
        document.documentElement.classList.toggle('header-compact', isCompact);
        if (wasCompact !== isCompact) {
          // Snap --header-height to the cached target so other consumers stay in sync;
          // sticky filters animate top via CSS (html.header-compact) in lockstep with the header.
          const key = isCompact ? '--header-compact-height' : '--header-expanded-height';
          const known = getComputedStyle(document.documentElement).getPropertyValue(key).trim();
          if (known) {
            document.documentElement.style.setProperty('--header-height', known);
          }
          window.clearTimeout(this.compactHeightTimer);
          this.compactHeightTimer = setTimeout(() => this.setHeaderHeight(), 400);
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
